'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var createGetFormMeta = function createGetFormMeta(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.fields') || empty;
    };
  };
};

exports.default = createGetFormMeta;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/selectors/getFormMeta.js
// module id = 216
// module chunks = 0